import { useEffect, useState } from "react";
import styled from "@emotion/styled";
import padding from "../../Styles/padding";

export default function SubscriptionForm() {
  let [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);

  return mounted ? <Form /> : null;
}

let FloatingLabelInput;

let Layout = styled.form`
  max-width: 800px;
  margin: 0 auto;
`;

let NameInputs = styled.div`
  margin: calc(${padding.large} - ${padding.standard}) auto;
  display: grid;
  grid-gap: calc(${padding.large} - ${padding.standard});

  @media(min-width: 480px) {
    grid-template-columns: repeat(2, 1fr);
    grid-gap: ${padding.large};
  }
`;

let EmailAndSubmit = styled.div`
  margin: calc(${padding.large} - ${padding.standard}) auto;
  display: grid;
  grid-gap: calc(${padding.large} - ${padding.standard});

  @media(min-width: 480px) {
    grid-template-columns: 1fr max-content;
    grid-gap: ${padding.large};
  }
`;

function Form() {
  FloatingLabelInput = FloatingLabelInput || require('../../Portal/components/FloatingLabelInput').default;

  let [firstName, setFirstName] = useState(undefined);
  let [lastName, setLastName] = useState(undefined);
  let [email, setEmail] = useState(undefined);

  let [isSubmitting, setIsSubmitting] = useState(false);

  return <Layout action="https://api.genoo.com/servlet/PostForm" method="post">
    <input type="hidden" name="form_key" value="000fpk21280734:cjwdngt@vrv.qti" />
    <input type="hidden" name="returl" value="https://www.tpt.org/streaming-thank-you/" />
    <NameInputs>
      <FloatingLabelInput label="First Name" errorMessage="First Name is required">
        <input
          id="first-name"
          name="first_name"
          value={firstName}
          placeholder="First Name"
          type="text"
          onChange={e => setFirstName(e.target.value)}
          disabled={isSubmitting}
        />
      </FloatingLabelInput>
      <FloatingLabelInput label="Last Name" errorMessage="Last Name is required">
        <input
          id="last-name"
          name="last_name"
          value={lastName}
          placeholder="Last Name"
          type="text"
          onChange={e => setLastName(e.target.value)}
          disabled={isSubmitting}
        />
      </FloatingLabelInput>
    </NameInputs>
    <EmailAndSubmit>
      <FloatingLabelInput label="Email" errorMessage="Email is required">
        <input
          id="email"
          name="email"
          value={email}
          placeholder="Email"
          type="text"
          onChange={e => setEmail(e.target.value)}
          disabled={isSubmitting}
        />
      </FloatingLabelInput>
      <button className="theme-btn" style={{ margin: `${padding.standard} 0 0` }}>Subscribe Now</button>
    </EmailAndSubmit>
  </Layout>;
}